<template>
    <div class="camsContainer">
        <div class="pageHeader">
            <ContentHeader name="Dashboard" :subHeader="subHeader" />
            <button v-if="scanKeyModalEnabled" @click="(event) => handleButtonPress(event)">Scan Key</button>
        </div>
        <!-- <Insights :cardInfo="cardInfo" :callback="updateFiltersForSearchBasedOnCard" /> -->
        <div class="widget-container">
            <Widget class="widget" v-for="widget in newWidgets" :key="widget.title" :widget="widget" />
        </div>

    </div>

</template>


<script>
import ContentHeader from '../ContentHeader.vue';
// import Insights from '../layout/Insights.vue';
import Widget from './pageComps/widget/Widget.vue';
import CTSRepository from '../../js/CTSRepository';
import EventBus from '../../eventBus';
import * as Constants from '../../js/constants'

export default {
    name: "Dashboard",
    components: {
        ContentHeader,
        // Insights,
        Widget
    },
    props: ['userData', 'organizationData'],
    created() {
        this.fetchIncomingKeysForToday()
    },
    methods: {
        defaultTableCallback(item) {
            console.log("item", item)
            alert(`Clicked a widget item - ${item.title}`)
        },
        getStartOfTomorrowUTC() {
            const now = new Date();
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;


            // Get today's date parts in the user's timezone
            const parts = new Intl.DateTimeFormat("en-CA", {
                timeZone,
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
            }).formatToParts(now);

            const year = parts.find(p => p.type === "year").value;
            const month = parts.find(p => p.type === "month").value;
            const day = parts.find(p => p.type === "day").value;

            // Build "today midnight" in that timezone
            const todayLocalMidnight = new Date(`${year}-${month}-${day}T00:00:00`);

            // Move to tomorrow midnight (still in that timezone context)
            const tomorrowLocalMidnight = new Date(todayLocalMidnight);
            tomorrowLocalMidnight.setDate(tomorrowLocalMidnight.getDate() + 1);

            // Convert to UTC string
            return tomorrowLocalMidnight.toISOString();
        },
        fetchIncomingKeysForToday() {
            //const today = new Date()
            const tomorrow = new Date()
            tomorrow.setDate(tomorrow.getDate() + 1)

            new CTSRepository(this.$props.organizationData).getIncomingVisitorsWidget({
                active_time_end: this.getStartOfTomorrowUTC()
            }).then(data => {
                console.log("Recived Incoming Visitor Data", data)
                this.incomingKeys = data.data
                const keyWidgetConfiguration = {
                    title: "Incoming Visitors Today",
                    type: "widgetTable",
                    emptyDataMessage: "No incoming keys scheduled for today",
                    data: data.data.map(item => {
                        let deliveryDetails = ""
                        switch (item.delivery_methods) {
                            case "sms":
                            case "email,sms":
                            case "sms,email":
                                deliveryDetails = `\n${item.visitor_phone_number}`;
                                break;
                            case "email":
                                deliveryDetails = `\n${item.visitor_email}`;
                                break;
                        }
                        return {
                            title: `${item.unit_data.unit_full_address ?? item.user_address}`,
                            subtitle: `${item.visitor_first_name} ${item.visitor_last_name} Visiting ${item.user_first_name} ${item.user_last_name}${deliveryDetails}`,
                            details: `Key Active at ${new Date(item.time_active).toLocaleTimeString()}`,
                            action: () => this.openKeyModal(item)
                        }
                    }).sort((a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()))
                }
                this.keyWidgetConfiguration = keyWidgetConfiguration
            })
        },
        openKeyModal(item) {
            EventBus.$emit(Constants.UPDATE_KEY_MODAL_DATA, item)
        },
        handleButtonPress() {
            this.$modal.show(Constants.SCAN_KEY_MODAL)
        },
    },
    watch: {
        userData: function (newVal, oldVal) {
            console.log("userData changed: ", newVal, " | was: ", oldVal);
            this.localUserData = newVal
            //this.subHeader = `Here's what's going on today in ${newVal['custom:cts_property_id']}!`
        },
        organizationData: function (newVal) {
            this.subHeader = `Here's what's going on today in ${newVal.organization_name}!`
        },
        // incomingKeys: function (newVal) {
        //     // const keyWidgetConfiguration = {
        //     //     title: "Incoming Visitors Today",
        //     //     type: "widgetTable",
        //     //     data: newVal.map(item => ({
        //     //         title: `${item.visitor_first_name} ${item.visitor_last_name}`,
        //     //         subtitle: `Visiting ${item.user_first_name} ${item.user_last_name} | ${item.user_first_name} | ${item.visitor_phone_number}`,
        //     //         details: "Expected Arrival: 8:30 - 10:30",
        //     //         action: (item) => this.defaultTableCallback(item)
        //     //     }))
        //     // }
        //     // this.widgets = [keyWidgetConfiguration]
        // }
    },
    computed: {
        newWidgets: function () {
            return [this.keyWidgetConfiguration, this.incidentsWidgetConfiguration, this.digitalKeyAdoptionWidgetConfiguration, this.todosWidgetConfiguration]
        },
        scanKeyModalEnabled: function () {
            const enabled = this.$featureEnabledForRole(Constants.SCAN_KEY_MODAL, this.$props.userData['custom:cts_role'])
            console.log("Is Scan Key Featured Enabled for Role", this.$props.userData['custom:cts_role'], enabled)
            return enabled
        }
    },
    data() {
        console.log("Dashboard User data", this.$props.userData)
        return {
            localUserData: {},
            subHeader: `Here's what's going on today in ${this.$props.organizationData.organization_name}`,
            incomingKeys: [],
            keyWidgetConfiguration: {},
            incidentsWidgetConfiguration: {
                title: "Incidents Reported Today",
                type: "widgetBarChart",
                emptyDataMessage: "No Incidents Reported Today",
                data: [],
            },
            digitalKeyAdoptionWidgetConfiguration: {
                title: "Digital Key Adoption Metrics This Month",
                type: "widgetPieChart",
                emptyDataMessage: "No data available",
            },
            todosWidgetConfiguration: {
                title: "Your To-Do's",
                type: "widgetTable",
                emptyDataMessage: "You're all caught up!",
                data: []
                // data: [
                //     {
                //         title: "HOA Dues Overdue",
                //         subtitle: "Jason Quintana",
                //         details: "Amount Due: $120",
                //         action: (item) => this.defaultTableCallback(item)

                //     },
                //     {
                //         title: "New Vehicle Tag Requested",
                //         subtitle: "Richard Dale | 2024 Acura TSX | VJ7X61",
                //         details: "Due Date: Today",
                //         action: (item) => this.defaultTableCallback(item)

                //     },
                //     {
                //         title: "Update Resident Information",
                //         subtitle: "Daniel Sypioe | Update Secondary Email",
                //         details: "Due Date: Tomorrow",
                //         action: (item) => this.defaultTableCallback(item)

                //     },
                //     {
                //         title: "Facility Request",
                //         subtitle: "Clubhouse Bathroom Out of Order",
                //         details: "Due Date: 11/30/2024",
                //         action: (item) => this.defaultTableCallback(item)

                //     },
                //     {
                //         title: "Resident Violation",
                //         subtitle: "Saud Hasnain | Pressure Cleaning Violation",
                //         details: "Amount Due: $50",
                //         action: (item) => this.defaultTableCallback(item)

                //     },
                //     {
                //         title: "HOA Dues Overdue",
                //         subtitle: "Jason Quintana",
                //         details: "Amount Due: $120",
                //     },
                // ]
            },
            widgets: [
                {
                    title: "Incoming Visitors Today",
                    type: "widgetTable",
                    data: [
                        {
                            title: "Richard Dale",
                            subtitle: "Visiting Jason Quintana | 624 SW 180th Ave. Pembroke Pines, FL | 954-394-2449",
                            details: "Expected Arrival: 8:30 - 10:30",
                            action: (item) => this.defaultTableCallback(item)
                        },
                        {
                            title: "Richard Dale",
                            subtitle: "Visiting Jason Quintana | 624 SW 180th Ave. Pembroke Pines, FL | 954-394-2449",
                            details: "Expected Arrival: 8:30 - 10:30",
                            action: (item) => this.defaultTableCallback(item)

                        },
                        {
                            title: "Richard Dale",
                            subtitle: "Visiting Jason Quintana | 624 SW 180th Ave. Pembroke Pines, FL | 954-394-2449",
                            details: "Expected Arrival: 8:30 - 10:30",
                            action: (item) => this.defaultTableCallback(item)
                        },
                        {
                            title: "Richard Dale",
                            subtitle: "Visiting Jason Quintana | 624 SW 180th Ave. Pembroke Pines, FL | 954-394-2449",
                            details: "Expected Arrival: 8:30 - 10:30",
                            action: (item) => this.defaultTableCallback(item)

                        },
                        {
                            title: "Richard Dale",
                            subtitle: "Visiting Jason Quintana | 624 SW 180th Ave. Pembroke Pines, FL | 954-394-2449",
                            details: "Expected Arrival: 8:30 - 10:30",
                            action: (item) => this.defaultTableCallback(item)
                        },
                        {
                            title: "Richard Dale",
                            subtitle: "Visiting Jason Quintana | 624 SW 180th Ave. Pembroke Pines, FL | 954-394-2449",
                            details: "Expected Arrival: 8:30 - 10:30",
                            action: (item) => this.defaultTableCallback(item)
                        },
                    ]
                },
                {
                    title: "Incidents Reported Today",
                    type: "widgetBarChart",
                    data: [],
                },
                {
                    title: "Digital Key Adoption Metrics This Month",
                    type: "widgetPieChart",

                },
                {
                    title: "Your To-Do's",
                    type: "widgetTable",
                    data: [
                        {
                            title: "HOA Dues Overdue",
                            subtitle: "Jason Quintana",
                            details: "Amount Due: $120",
                            action: (item) => this.defaultTableCallback(item)

                        },
                        {
                            title: "New Vehicle Tag Requested",
                            subtitle: "Richard Dale | 2024 Acura TSX | VJ7X61",
                            details: "Due Date: Today",
                            action: (item) => this.defaultTableCallback(item)

                        },
                        {
                            title: "Update Resident Information",
                            subtitle: "Daniel Sypioe | Update Secondary Email",
                            details: "Due Date: Tomorrow",
                            action: (item) => this.defaultTableCallback(item)

                        },
                        {
                            title: "Facility Request",
                            subtitle: "Clubhouse Bathroom Out of Order",
                            details: "Due Date: 11/30/2024",
                            action: (item) => this.defaultTableCallback(item)

                        },
                        {
                            title: "Resident Violation",
                            subtitle: "Saud Hasnain | Pressure Cleaning Violation",
                            details: "Amount Due: $50",
                            action: (item) => this.defaultTableCallback(item)

                        },
                        {
                            title: "HOA Dues Overdue",
                            subtitle: "Jason Quintana",
                            details: "Amount Due: $120",
                        },
                    ]
                },
            ],
            cardInfo: [
                {
                    title: "Total Keys for Today",
                    value: "7",
                    filters: {

                    }
                },
                {
                    title: "Urgent Incidents Today",
                    value: "5",
                    filters: {
                        residentName: "",
                        visitorName: "",
                        subdivision: "",
                        status: "VALIDATED",
                        startTime: null,
                        endTime: null
                    }
                },
                {
                    title: "Tasks To-Do",
                    value: "3",
                },
                {
                    title: "Event Today",
                    value: "1",
                },
                {
                    title: "Move-in Today",
                    value: "1",
                    filters: {
                        residentName: "",
                        visitorName: "",
                        subdivision: "",
                        status: "CREATED",
                        startTime: null,
                        endTime: null
                    }
                }
            ],
        };
    },
};
</script>

<style scoped>
@media(0px <=width <=600px) {
    .widget-container {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 16px;
    }

    .widget {
        width: 100%;
        max-height: 300px;
        display: block;
        padding-left: 1em;
        padding-right: 1em;
        padding-bottom: 1em;
        text-align: left;
        background-color: white;
        border-radius: 5px;
        margin-bottom: 25px;
        overflow-y: auto;

    }
}

@media (width > 600px) {
    .widget-container {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 16px;
    }

    .widget {
        width: 49%;
        min-width: 350px;
        max-height: 300px;
        display: block;
        padding-left: 1em;
        padding-right: 1em;
        padding-bottom: 1em;
        text-align: left;
        background-color: white;
        border-radius: 5px;
        margin-bottom: 25px;
        overflow-y: auto;

    }
}

.pageHeader button {
    background-color: #1890FFCC !important;
}
</style>